import * as React from "react";
import Image from "next/image";
import { shimmer, toBase64 } from "@src/utils/shimmer";
import Dialog from "src/components/Dialog";
// import Icon from "../Icon";
import Link from "next/link";
import Button from "@src/components/Button";
import { GetAlbumDetailsQuery } from "@src/@types/api.d";

type Props = {
  eventId: number;
  albumDetailsData: GetAlbumDetailsQuery;
  eventSlug: string;
};

export function insertAt(
  array: unknown[],
  index: number,
  ...elementsArray: unknown[]
) {
  array.splice(index, 0, ...elementsArray);
}

const Masonry: React.FC<Props> = ({ eventId, eventSlug, albumDetailsData }) => {
  const imageMedia =
    albumDetailsData?.getMedia?.filter((media) =>
      media?.type?.toLowerCase().includes("image")
    ) || [];

  return imageMedia.length > 0 ? (
    <div className="bg-[#8C7756] border-b border-b-[#EBE3CE] py-[6rem] sm:py-[9rem]  px-4">
      <div
        className={`grid max-w-full grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-4 md:gap-6 mb-12`}
      >
        {imageMedia.slice(0, 4)?.map((image, index) => {
          if (image && image.meta?.s3_url) {
            return (
              <div
                className={`relative aspect-[0.865] cursor-pointer rounded-2xl transition duration-500 hover:scale-[1.02]`}
                key={index}
              >
                <Image
                  placeholder="blur"
                  blurDataURL={`data:image/svg+xml;base64,${toBase64(
                    shimmer(700, 475)
                  )}`}
                  // src={
                  //   "http://res.cloudinary.com/inawo-medias/image/upload/v1658851148/prod/kmsjifymcoyinbuzkm4t.jpg?inawoHeight=6880&inawoWidth=5504"
                  // }
                  src={image.meta.s3_url}
                  layout="fill"
                  alt="gallery"
                  objectFit="cover"
                  className="rounded-2xl object-top"
                />
                {/* {image.type?.includes("image") ? (
                    ) : (
                      <video autoPlay={false} controls></video>
                    )} */}
                {/* <p className="text-red-500">{image.meta.s3_url}</p> */}
              </div>
            );
          }
        })}
      </div>

      <div
        className={`flex flex-col md:flex-row gap-8 justify-center items-center`}
      >
        <Link
          href={`https://${eventSlug}.${process.env.NEXT_PUBLIC_INAWO_ALBUM_SITE_END}`}
          passHref
        >
          <a target="_blank">
            <button
              className="px-6 py-2 rounded transition duration-300 border border-white text-white font-inter hover:border-[#EDAC06]"
              type="button"
            >
              See full photobook
            </button>
          </a>
        </Link>
        {/* <Link
            href={`https://${eventSlug}.${process.env.NEXT_PUBLIC_INAWO_ALBUM_SITE_END}`}
            passHref
          >
            <a target="_blank">
              <Button design="other" type="button" label="View More">
                Add your photos
              </Button>
            </a>
          </Link> */}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default Masonry;
